import React, { useId } from 'react';
import { formatLeverValue, formatSignedPercent } from '../format';

const LeverSlider = ({ leverId, label, currentValue, delta, maxDelta, onChange, disabled }) => {
  const id = useId();
  const percent = delta * 100;
  const maxPercent = maxDelta * 100;
  const fill = maxPercent > 0 ? Math.min(100, (percent / maxPercent) * 100) : 0;
  const newValue = currentValue * (1 + delta);

  return (
    <div className={`dg-slider${disabled ? ' is-disabled' : ''}`}>
      <div className="dg-slider-head">
        <label className="dg-slider-label" htmlFor={id}>
          {label}
        </label>
        <span className="dg-slider-delta">{formatSignedPercent(percent)}</span>
      </div>

      <input
        id={id}
        className="dg-slider-input"
        type="range"
        min={0}
        max={maxPercent}
        step={1}
        value={percent}
        disabled={disabled}
        onChange={(event) => onChange(Number(event.target.value) / 100)}
        style={{ '--dg-slider-fill': `${fill}%` }}
      />

      <div className="dg-slider-foot">
        <span className="dg-slider-now">{formatLeverValue(leverId, currentValue)}</span>
        <span className="dg-slider-arrow" aria-hidden="true">
          →
        </span>
        <span className="dg-slider-next">{formatLeverValue(leverId, newValue)}</span>
      </div>
    </div>
  );
};

export default LeverSlider;
